import React from 'react';
import { Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { SquareIconButton } from 'src/UIKit';

interface MessageAccordionTitleProps {
  /** Message snippet, already sanitised by formatUnicodeStylesToSafeHtml. */
  snippetHtml: string;
  scheduleLabel: string;
  /** Position among the messages, 0-based — used for the remove label. */
  index: number;
  showRemove: boolean;
  removeDisabled: boolean;
  onRemove: () => void;
}

/**
 * Collapsed-accordion header for one message: the snippet, its schedule caption
 * and the remove button. The delete control renders for every message after the
 * first and is merely disabled when that message is read-only.
 */
export const MessageAccordionTitle: React.FC<MessageAccordionTitleProps> = ({
  snippetHtml,
  scheduleLabel,
  index,
  showRemove,
  removeDisabled,
  onRemove,
}) => (
  <Box
    overflow="hidden"
    width="100%"
    display="grid"
    gridTemplateColumns="minmax(0, 1fr) auto"
    alignItems="center"
    columnGap={2}
  >
    <Box minWidth={0} textAlign="left">
      <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
        <span
          // Sanitised by formatUnicodeStylesToSafeHtml.
          dangerouslySetInnerHTML={{ __html: snippetHtml }}
        />
      </Box>
      <Box
        mt={0.5}
        color="grey.400"
        typography="body2"
        display="flex"
        justifyContent="space-between"
        width="100%"
      >
        <Box height={18}>{scheduleLabel}</Box>
      </Box>
    </Box>
    <Box color="grey.400" typography="body2" display="flex" alignItems="center" flexShrink={0}>
      {showRemove && (
        <SquareIconButton
          sx={{ width: 40 }}
          size="small"
          color="primary"
          disabled={removeDisabled}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label={`Remove message ${index + 1}`}
        >
          <DeleteIcon style={{ transform: 'scale(0.8)' }} />
        </SquareIconButton>
      )}
    </Box>
  </Box>
);
